import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

type ColorScheme = 'white' | 'blue';

interface FrameProps {
  colorScheme: ColorScheme;
  position?: 'vertical' | 'horizontal';
  overlapTop?: boolean;
  headline: React.ReactElement;
  features: React.ReactElement;
  disclosures: React.ReactElement;
}

const Frame: React.FC<FrameProps> = ({
  colorScheme,
  position,
  overlapTop,
  headline,
  features,
  disclosures,
}) => {
  const Styles = useMultiStyleConfig('Frame', {
    colorScheme,
    variant: position,
  });
  return (
    <Box>
      <Box as="section" sx={Styles.frame}>
        {headline && <Box sx={Styles.header}>{headline}</Box>}
        <Box
          sx={Styles.content}
          width="full"
          display="flex"
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems="center"
        >
          {features}
        </Box>
      </Box>
      <Box maxW="1126px" sx={Styles.disclosures}>
        {disclosures}
      </Box>
    </Box>
  );
};

export default Frame;
